import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext.jsx';
import { logger } from '../../lib/logger.js';
import ErrorFallback from './ErrorFallback.jsx';

export default function RouteErrorBoundary({ children }) {
  const location = useLocation();
  const { user } = useAuth() ?? {};
  const userId = user?.username;
  const routeName = location.pathname;

  function FallbackComponent(props) {
    return (
      <ErrorFallback
        {...props}
        variant="route"
        routeName={routeName}
        userId={userId}
      />
    );
  }

  function handleError(error) {
    logger.error('react-error-boundary-route', { error, route: routeName });
  }

  return (
    <ErrorBoundary FallbackComponent={FallbackComponent} onError={handleError} resetKeys={[routeName]}>
      {children}
    </ErrorBoundary>
  );
}
